import styled from 'styled-components';
import { skeletonAnimation } from 'src/styles';

export const Avatar = styled.div`
  width: 4.75rem;
  height: 4.75rem;
  flex-shrink: 0;
  ${skeletonAnimation}
`;

Avatar.displayName = 'Avatar';

export const UserName = styled.div`
  width: 7.875rem;
  height: 0.5rem;
  flex-shrink: 0;
  ${skeletonAnimation}
`;

UserName.displayName = 'UserName';
